<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "edit-lifecycle-information.title" | t }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'edit-lifecycle-information.instructionText' | t
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "edit-lifecycle-information.subTitle" | t }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <div class="section-row">
                <app-cerrix-datepicker-group
                    data-uiid="asset-edit-date-in-use"
                    format="dd-MM-yyyy"
                    [placeholder]="
                        'edit-lifecycle-information.dateInUsePlaceholder'
                            | t
                    "
                    [infoText]="
                        'edit-lifecycle-information.dateInUseInfo' | t
                    "
                    [(value)]="editModel.lifecycle.dateInUse"
                    >{{
                        "edit-lifecycle-information.dateInUseLabel" | t
                    }}</app-cerrix-datepicker-group
                >
                <app-cerrix-datepicker-group
                    data-uiid="asset-edit-date-out-of-use"
                    format="dd-MM-yyyy"
                    [placeholder]="
                        'edit-lifecycle-information.dateOutOfUsePlaceholder'
                            | t
                    "
                    [infoText]="
                        'edit-lifecycle-information.dateOutOfUseInfo' | t
                    "
                    [mustBeAfter]="editModel.lifecycle.dateInUse"
                    [afterErrorMessage]="
                        'edit-lifecycle-information.dateOutOfUseErrorMessage'
                            | t
                    "
                    [(value)]="editModel.lifecycle.dateOutOfUse"
                    >{{
                        "edit-lifecycle-information.dateOutOfUseLabel" | t
                    }}</app-cerrix-datepicker-group
                >
            </div>
        </div>
    }
</div>

<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="closeEdit.emit()"
    >
        {{ "detail.cancelButton" | t }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="save()"
    >
        {{ "detail.editSaveButton" | t }}
    </cerrix-button>
</div>
